export const enMovieMetaDesc = [
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Find all streaming options on JustWatch, including free & 4K.',
		v1_max_length: 112,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every option on JustWatch, including free & 4K.',
		v2_max_length: 112,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 117,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Find all streaming options on JustWatch, including free & 4K.',
		v1_max_length: 120,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 129,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 124,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. See all options on JustWatch, including free & 4K.',
		v1_max_length: 114,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 134,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 129,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Compare all options, including free & 4K.',
		v1_max_length: 115,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 144,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 121,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Find all options on JustWatch, including free & 4K.',
		v1_max_length: 135,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. See all options, including free.',
		v2_max_length: 122,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 129,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}} & 1 other service. See all options, including free & 4K.',
		v1_max_length: 139,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service. See all options, including free.',
		v2_max_length: 140,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 147,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}} & {{restCount}} other services. See all options, including free & 4K.',
		v1_max_length: 144,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services. See all options, including free.',
		v2_max_length: 145,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 152,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Check all options on JustWatch, including free & 4K.',
		v1_max_length: 113,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every option on JustWatch, including free & 4K.',
		v2_max_length: 121,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 126,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Check out all options, including free & 4K.',
		v1_max_length: 111,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 138,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 133,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. See all streaming options, including free & 4K.',
		v1_max_length: 120,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 143,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 120,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. See all streaming options, including free & 4K.',
		v1_max_length: 130,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. See all options, including free.',
		v2_max_length: 123,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 123,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. All streaming options on JustWatch.',
		v1_max_length: 128,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. See all options, including free & 4K.',
		v2_max_length: 136,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 138,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}} & 1 other service. See all options, including free & 4K.',
		v1_max_length: 148,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service. See all options, including free & 4K.',
		v2_max_length: 154,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service. Updated on {{lastUpdatedAt}}.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}} & {{restCount}} other services. Find all options on JustWatch.',
		v1_max_length: 146,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services. See all options, including free.',
		v2_max_length: 154,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services. Updated on {{lastUpdatedAt}}.',
		v3_max_length: 156,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Check out all streaming options, including free & 4K.',
		v1_max_length: 125,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 142,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 137,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. See all streaming options, including free & 4K.',
		v1_max_length: 126,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 149,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. Check out all options, including free & 4K.',
		v1_max_length: 127,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find every streaming option on JustWatch, including free & 4K.',
		v2_max_length: 154,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 124,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. Find all options on JustWatch.',
		v1_max_length: 124,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. All options on JustWatch, including free & 4K.',
		v2_max_length: 148,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 134,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. Check out all options.',
		v1_max_length: 126,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. See all options, including free & 4K.',
		v2_max_length: 147,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 142,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}} & 1 other service.',
		v1_max_length: 122,
		v2_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service.',
		v2_max_length: 128,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service.',
		v3_max_length: 127,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}} & {{restCount}} other services.',
		v1_max_length: 127,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services.',
		v2_max_length: 133,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services.',
		v3_max_length: 132,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. All options on JustWatch, incl. free.',
		v1_max_length: 129,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Find all options on JustWatch, including free & 4K.',
		v2_max_length: 151,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 139,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. See all options, including free & 4K.',
		v1_max_length: 136,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. All options on JustWatch, including free & 4K.',
		v2_max_length: 153,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 146,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. See all options, including free & 4K.',
		v1_max_length: 141,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. All options on JustWatch, incl. free & 4K.',
		v2_max_length: 154,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. See all options, including free & 4K.',
		v1_max_length: 151,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. All options, including free & 4K.',
		v2_max_length: 155,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 154,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. All options, including free.',
		v1_max_length: 152,
		v2_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Free & 4K on JustWatch.',
		v2_max_length: 153,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}.',
		v3_max_length: 130,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}} & 1 other service.',
		v1_max_length: 142,
		v2_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service.',
		v2_max_length: 147,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service.',
		v3_max_length: 147,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}} & {{restCount}} other services.',
		v1_max_length: 146,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services.',
		v2_max_length: 152,
		v3_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services.',
		v3_max_length: 152,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. All options on JustWatch, including free & 4K.',
		v1_max_length: 146,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. Compare all options, including free & 4K.',
		v2_max_length: 149,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 140,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming now on {{providerNames}}. All options on JustWatch, including free & 4K.',
		v1_max_length: 153,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. See all options, including free & 4K.',
		v2_max_length: 152,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 147,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" is streaming on {{providerNames}}. All options on JustWatch, including free & 4K.',
		v1_max_length: 154,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}}. See all options, including free & 4K.',
		v2_max_length: 157,
		v3_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 152,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. Find all options on JustWatch.',
		v1_max_length: 152,
		v2_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}. All options on JustWatch.',
		v2_max_length: 155,
		v3_translatable: 'Watch "{{titleName}}" online on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}}. See all options.',
		v1_max_length: 147,
		v2_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}}.',
		v2_max_length: 138,
		v3_translatable: 'Watch "{{titleName}}" now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}} & 1 other service.',
		v1_max_length: 150,
		v2_translatable: 'Watch "{{titleName}}" legally online now on {{providerNames}} & 1 other service.',
		v2_max_length: 155,
		v3_translatable: 'Watch "{{titleName}}" online now on {{providerNames}} & 1 other service.',
		v3_max_length: 147,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '"{{titleName}}" is streaming now on {{providerNames}} & {{restCount}} other services.',
		v1_max_length: 155,
		v2_translatable:
			'Watch "{{titleName}}" legally online now on {{providerNames}} & {{restCount}} other services.',
		v2_max_length: 160,
		v3_translatable: 'Watch "{{titleName}}" online now on {{providerNames}} & {{restCount}} other services.',
		v3_max_length: 152,
	},
];
